import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Search, X } from "lucide-react";
import { LOGO_URL } from "@/data/blogPosts";

const navItems = [
  { label: "الرئيسية", path: "/" },
  { label: "من نحن", path: "/about" },
  { label: "الخدمات", path: "/services" },
  { label: "الأنشطة", path: "/activities" },
  { label: "حول الصين", path: "/china" },
  { label: "المدونة", path: "/blog" },
  { label: "معرض الصور", path: "/gallery" },
  { label: "اتصل بنا", path: "/contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 shadow-lg shadow-black/5 border-b border-gold/20" dir="rtl">
      {/* @section: main-navigation */}
      <nav className="container-pal flex h-20 items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0" aria-label="PalChina الرئيسية">
          <img src={LOGO_URL} alt="شعار جمعية الصداقة الفلسطينية الصينية" className="h-14 w-14 rounded-full object-contain bg-white p-1 shadow" loading="eager" />
          <div className="hidden sm:block leading-tight">
            <p className="text-lg font-black text-black">PalChina.org</p>
            <p className="text-xs font-bold text-pal-green">جمعية الصداقة الفلسطينية الصينية</p>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `px-3 py-2 rounded-full text-sm font-bold transition-all duration-200 ${isActive ? "bg-chinese-red text-white shadow-md" : "text-black hover:bg-cream hover:text-chinese-red"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <button className="rounded-full border border-border px-3 py-2 text-sm font-bold hover:border-gold hover:text-chinese-red" aria-label="تبديل اللغة">AR / EN</button>
          <button className="h-10 w-10 grid place-items-center rounded-full bg-cream text-black hover:text-chinese-red" aria-label="بحث"><Search size={19} /></button>
          <Link to="/contact" className="rounded-full bg-chinese-red px-5 py-2.5 text-sm font-extrabold text-white shadow-lg shadow-chinese-red/25 hover:bg-deep-red">تواصل معنا</Link>
        </div>

        <button className="lg:hidden h-11 w-11 grid place-items-center rounded-full bg-cream" onClick={() => setOpen((v) => !v)} aria-label="فتح القائمة">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-border bg-white px-4 pb-5 shadow-xl">
          <div className="grid gap-2 pt-3">
            {navItems.map((item) => (
              <NavLink key={item.path} to={item.path} onClick={() => setOpen(false)} className={({ isActive }) => `rounded-2xl px-4 py-3 font-bold ${isActive ? "bg-chinese-red text-white" : "bg-cream text-black"}`}>
                {item.label}
              </NavLink>
            ))}
            <div className="flex items-center gap-2 pt-2">
              <button className="flex-1 rounded-2xl border border-border px-4 py-3 font-bold">AR / EN</button>
              <button className="rounded-2xl bg-cream px-4 py-3" aria-label="بحث"><Search /></button>
              <Link to="/contact" onClick={() => setOpen(false)} className="flex-1 text-center rounded-2xl bg-chinese-red px-4 py-3 font-extrabold text-white">تواصل معنا</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
